module.exports = "/packs/002-bfc1f15318dd876735c51185a242ee2d.jpg";